import {
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  toastShow,
} from 'mailup-web-components'

import getIntl from 'Helpers/intl'

import {
  beAutomationApiCopyWorkflow,
  beAutomationApiDeleteWorkflow,
  beAutomationApiSimulateWorkflow,
} from 'Api/beAutomationApiTS'

import type { SimulateResult } from 'Pages/UnsubscriptionCampaignsList/types'

export const copyWorkflow = async (idWorkflow: number): Promise<boolean> => {
  const { Result } = await beAutomationApiCopyWorkflow(idWorkflow)

  return Result
}

export const notifyCopy = (success: boolean): void => {
  toastShow(
    getIntl().formatMessage({
      id: success ? 'Load.Alerts.SuccessCopy' : 'Load.Alerts.ErrorGeneric',
    }),
    success ? TOAST_VARIANT_SUCCESS : TOAST_VARIANT_ERROR,
    'ModalCopyConfirm',
  )
}

export const notifyDelete = (): void => {
  toastShow(
    getIntl().formatMessage({
      id: 'Load.AutomationWorkflow.AlertMessageDeleteSuccess',
    }),
    TOAST_VARIANT_SUCCESS,
    'ModalDeleteConfirm',
  )
}

export const simulateWorkflow = async (idWorkflow: number): Promise<number> => {
  const { Result } = await beAutomationApiSimulateWorkflow(idWorkflow)

  return Result
}

export const extractSimulateResult = (metadata?: string): SimulateResult => {
  if (metadata !== undefined) {
    try {
      const { TotalCount, Discarded } = JSON.parse(metadata)

      return {
        totalCount: TotalCount,
        discarded: Discarded,
      }
    } catch (error) {}
  }

  return {
    totalCount: undefined,
    discarded: undefined,
  }
}

export const deleteWorkflow = async (idWorkflow: number): Promise<void> => {
  await beAutomationApiDeleteWorkflow(idWorkflow)
}
